import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { useAddPatient, useUpdatePatientMutation } from '../../hooks/useGetDataQuery';
import { useToastContext } from '../../Lib/Contexts/toastContext';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { BlockUI } from 'primereact/blockui';
import { countries } from '../countryList';
import { usaStateList } from '../usaStateList';
import { countriesTurkish } from '../countryListTurkish';
import "./addPatientDialog.css";
import { useNavigate } from 'react-router-dom';
import { InputMask } from 'primereact/inputmask';
import { isIdValid, isPhoneNumberValid } from '../validations';
import { formatNameAndSurname } from '../format';

const AddPatientDialog = ({ t, setPatientList, addPatientDialogVisible, setAddPatientDialogVisible, selectedPatient = null,setSelectedPatient = null, isEditModeActive = false }: any) => {
    const { showToast } = useToastContext();
    const navigate = useNavigate();

    const [countyList, setCountyList] = useState<any>()

    const [patientName, setPatientName] = useState<any>()
    const [patientSurname, setPatientSurname] = useState<any>()
    const [nationality, setNationality] = useState<any>({ name: 'türkiye', code: 'TR', phoneCode: '+90' })
    const [state, setState] = useState<any>({ name: "Illinois", code: "IL", flag: "https://upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Illinois.svg" });
    const [nationalIdentityNumber, setNationalIdentityNumber] = useState<any>()
    const [blockUI, setBlockUI] = useState(false);

    const genderOptions = [t("gender.Male"), t("gender.Female")];
    const [gender, setGender] = useState(undefined);

    const [codeForPhoneNumber, setCodeForPhoneNumber] = useState<any>({ name: 'türkiye', code: 'TR', phoneCode: '+90' })
    const [phoneNumber, setPhoneNumber] = useState<any>()

    const [nameIsNotGiven, setNameIsNotGiven] = useState<any>(false)
    const [surnameIsNotGiven, setSurnameIsNotGiven] = useState<any>(false)
    const [nationalityIsNotGiven, setNationalityIsNotGiven] = useState<any>(false)
    const [stateIsNotGiven, setStateIsNotGiven] = useState<any>(false)
    const [nationalIdentityNumberIsNotGiven, setNationalIdentityNumberIsNotGiven] = useState<any>(false)
    const [phoneNumberIsNotGiven, setPhoneNumberIsNotGiven] = useState<any>(false)
    const [genderIsNotGiven, setGenderIsNotGiven] = useState<any>(false)

    const {
        mutate: addPatientMutation,
        data: addPatientMutationData,
        isSuccess: isSuccessAddPatientMutation,
        isError: isErrorAddPatientMutation,
        error: addPationtMutationError
    } = useAddPatient();

    const {
        mutate: updatePatientMutation,
        isSuccess: isSuccessPatientUpdate,
        data: updatePatientMutationData,
        isError: isErrorPatientUpdate,
        error: updatePatientMutationError
    } = useUpdatePatientMutation();

    const prepareNewPatient = () => {
        let genderTr = null
        if (gender === "Erkek") {
            genderTr = "Male"

        }
        if (gender === "Kadın") {
            genderTr = "Female"
        }

        const newPatien = {
            firstName: formatNameAndSurname(patientName),
            lastName: formatNameAndSurname(patientSurname),
            dateCreated: new Date(),
            nationality: nationality.code,
            nationalIdentityNumber: nationalIdentityNumber,
            phoneNumber: codeForPhoneNumber.code === "TR" ? codeForPhoneNumber.phoneCode + "" + parseInt(phoneNumber.replace(/\D/g, ""), 10) : codeForPhoneNumber.phoneCode + "" + phoneNumber,
            gender: genderTr ? genderTr : gender,
            isActive: true,
            id: isEditModeActive ? selectedPatient?.id : addPatientMutationData?.data?.id,
        }

        return newPatien;
    }

    useEffect(() => {
        if (updatePatientMutationData) {
            const newPatien = prepareNewPatient();
            setPatientList((prevList: any) => prevList.map((p:any) => {
                if(p.id === newPatien.id) {
                    return newPatien;
                }
                return p;
            }));
            onaddPatientDialogHide()
            setBlockUI(false)
            localStorage.setItem("patient", JSON.stringify(newPatien));
            setSelectedPatient(newPatien);
        } 
    }, [isSuccessPatientUpdate]);

    useEffect(() => {
        if (isErrorPatientUpdate) {
            setBlockUI(false)
            showToast({ severity: 'error', summary: 'Error', detail: updatePatientMutationError.message });
        }
    }, [isErrorPatientUpdate]);


    useEffect(() => {
        if (addPatientMutationData) {
            if (addPatientMutationData?.success) {
                const newPatien = prepareNewPatient();
                setPatientList((prevList: any) => prevList ? [newPatien, ...prevList] : [newPatien])
                onaddPatientDialogHide()
                setBlockUI(false)
                localStorage.setItem("patient", JSON.stringify(newPatien));
                navigate({ pathname: "/mobithera/prescription" })
            } else {
                setBlockUI(false)
                showToast({ severity: 'error', summary: 'Error', detail: addPatientMutationData.message });
            }
        }
    }, [isSuccessAddPatientMutation]);

    useEffect(() => {
        if (isErrorAddPatientMutation) {
            setBlockUI(false)
            showToast({ severity: 'error', summary: 'Error', detail: addPationtMutationError.response.data.Message });
        }
    }, [isErrorAddPatientMutation]);

    useEffect(() => {
        if (addPatientDialogVisible) {
            const langIsEn = localStorage.getItem("i18nextLng") === "en";

            const countryList = langIsEn
                ? countries
                : countriesTurkish

            setCountyList(countryList);

            let patientNationality = countryList.find(c => c.code === selectedPatient?.nationality) ?? { name: 'türkiye', code: 'TR', phoneCode: '+90' };

            setCodeForPhoneNumber(patientNationality);
            setNationality(patientNationality);

            setPatientName(selectedPatient ? selectedPatient.firstName : undefined);
            setPatientSurname(selectedPatient ? selectedPatient.lastName : undefined);
            setNationalIdentityNumber(selectedPatient ? selectedPatient.nationalIdentityNumber : undefined);

            let phoneNumber = selectedPatient?.phoneNumber;
            if (phoneNumber && patientNationality.phoneCode) {
                phoneNumber = phoneNumber
                    .replace(patientNationality.phoneCode, '')
                    .replace(/\s|-/g, '')
                    .trim();
            }
            setPhoneNumber(phoneNumber);

            let gender = selectedPatient?.gender;
            if (gender && !langIsEn) {
                if (gender === "Male") gender = "Erkek";
                else if (gender === "Female") gender = "Kadın";
            }
            setGender(gender);
        }
    }, [addPatientDialogVisible]);

    const onaddPatientDialogHide = () => {
        addPatientDefault()
        setAddPatientDialogVisible(false)
    }

    const validateFirstName = () => {
        if (!patientName || patientName?.trim() === "") {
            setNameIsNotGiven("requiredField");
            return false;
        }

        if(patientName?.length < 2 || patientName?.length > 50) {
            setNameIsNotGiven("firstNameInvalidLength");
            return false;
        }
        setNameIsNotGiven("")
        return true;
    }

    const validateSurname = () => {
        if (!patientSurname || patientSurname?.trim() === "") {
            setSurnameIsNotGiven("requiredField");
            return false;
        }

        if(patientSurname?.length < 2 || patientSurname?.length > 50) {
            setSurnameIsNotGiven("lastNameInvalidLength");
            return false;
        }
        setSurnameIsNotGiven("")
        return true;
    }

    const validateNationality = () => {
        if (!nationality) {
            setNationalityIsNotGiven("requiredField");
            return false;
        }
        if(nationality?.code === "US" && !state) {
            setStateIsNotGiven("requiredField");
            return false;
        }
        setStateIsNotGiven("")
        setNationalityIsNotGiven("")
        return true;
    }

    const validateNationalityNumber = () => {
        if(!isIdValid(nationalIdentityNumber)) {
            setNationalIdentityNumberIsNotGiven("invalidPatientId");
            return false;
        }
        if(nationalIdentityNumber?.length < 1 || nationalIdentityNumber?.length > 18) {
            setNationalIdentityNumberIsNotGiven("patientIdInvalidLength");
            return false;
        }
        setNationalIdentityNumberIsNotGiven("")
        return true;
    }

    const validatePhoneNumber = () => {
        if(!isPhoneNumberValid(phoneNumber, codeForPhoneNumber?.code)) {
            setPhoneNumberIsNotGiven("invalidPhoneNumber");
            return false;
        }
        setPhoneNumberIsNotGiven("")
        return true;
    }

    const validateGender = () => {
        if (!gender) {
            setGenderIsNotGiven("requiredField");
            return false;
        }
        setGenderIsNotGiven("")
        return true;
    }

    const onSavePatientDialog = () => {
        let escape = false
        if (!validateFirstName()) {
            escape = true
        }

        if (!validateSurname()) {
            escape = true
        }

        if (!validateNationality()) {
            escape = true
        }
        
        if (!validateNationalityNumber()) {
            escape = true
        }

        if (!validatePhoneNumber()) {
            escape = true
        }

        if (!validateGender()) {
            escape = true
        }

        if (escape) return;

        let genderTr = null
        if (gender === "Erkek") {
            genderTr = "Male"

        }
        if (gender === "Kadın") {
            genderTr = "Female"
        }

        const _cleanedPhoneNumber = String(phoneNumber).replace(/\D/g, "");
        const _phoneNumber = codeForPhoneNumber.phoneCode + _cleanedPhoneNumber;

        const newPatien = {
            firstName: formatNameAndSurname(patientName),
            lastName: formatNameAndSurname(patientSurname),
            dateCreated: new Date(),
            nationality: nationality.code,
            state: state ? state.code : null,
            nationalIdentityNumber: nationalIdentityNumber,
            phoneNumber: _phoneNumber,
            gender: genderTr ? genderTr : gender,
            isActive: true
        }

        setBlockUI(true)

        if(isEditModeActive) {
            const updatePatient = {...newPatien, id: selectedPatient.id};
            updatePatientMutation(updatePatient);
        } else {
            addPatientMutation(newPatien);
        }
    }

    const addPatientDefault = () => {
        setPatientName(undefined);
        setPatientSurname(undefined);
        setNationality(undefined)
        setNationalIdentityNumber(undefined);
        setPhoneNumber(undefined);
        setCodeForPhoneNumber(undefined);
        setGender(undefined)

        setNameIsNotGiven(false);
        setSurnameIsNotGiven(false);
        setNameIsNotGiven(false)
        setNationalityIsNotGiven(false)
        setNationalIdentityNumberIsNotGiven(false)
        setPhoneNumberIsNotGiven(false)
        setGenderIsNotGiven(false)
    }

    const toTitleCase = (str: any) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const selectedCountryTemplate = (option: any, props: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <img alt={option.name} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                        className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                    <div>{toTitleCase(option.name)}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const usaSelectedStateTemplate = (option: any, props: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <img alt={option.name} src={option.flag}
                        className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const selectedCountryTemplateForPhone = (option: any, props: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <img alt={option.name}
                        src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                        className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                    <p className='m-0'>{option.phoneCode}</p>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option: any) => {
        return (
            <div className="flex align-items-center">
                <img alt={t(option.name)} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                <div>{toTitleCase(option.name)}</div>
            </div>
        );
    };

    const usaStatesOptionTemplate = (option: any) => {
        return (
            <div className="flex align-items-center">
                <img alt={option.name} src={option.flag} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                <div>{option.name}</div>
            </div>
        );
    };

    const countryOptionTemplateForPhone = (option: any) => {
        return (
            <div className="flex align-items-center">
                <img alt={option.name} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                <div>{toTitleCase(option.name)}</div>
                <div className='ml-2'>{option.phoneCode}</div>
            </div>
        );
    };

    const headerContent = (
        <p className="m-0 text-md" style={{ color: "#727A99" }}>{!isEditModeActive ? t('newPatient') : t('updatePatient')}</p>
    );

    const footerContent = (
        <div className="flex justify-content-end gap-2">
            <Button
                style={{
                    backgroundColor: "white",
                    width: "10rem",
                    height: "3rem",
                    borderRadius: "10px",
                    border: "1.5px solid #2D3967",
                    color: "#2D3967",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem"
                }}
                onClick={onaddPatientDialogHide}
            >
                <img src="/cancel.svg" />
                <p className="m-0 font-bold" style={{ margin: 0 }}>{t("cancel")}</p>
            </Button>
            <Button
                style={{
                    backgroundColor: "#E3506B",
                    width: "14rem",
                    height: "3rem",
                    borderRadius: "10px",
                    color: "white",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem"
                }}
                onClick={onSavePatientDialog}
            >
                <img src="/accept.svg" />
                <p className="m-0 font-bold" style={{ margin: 0 }}>{!isEditModeActive ? t('savePatient') : t('updatePatient')}</p>
            </Button>
        </div>
    );

    const renderPhoneNumberInput = () => {
        switch(codeForPhoneNumber?.code) {
            case "TR": 
                return (
                    <InputMask mask="(999) 999 99 99" placeholder="(5xx) xxx xx xx" className={!!phoneNumberIsNotGiven ? "p-invalid mr-2 w-full" : "w-full"}
                        value={phoneNumber} onChange={(e) => setPhoneNumber(e.value)} style={{ height: "3rem" }}></InputMask>
                );
            case "AZ": 
                return (
                    <InputMask mask="(99) 999 99 99" placeholder="(xx) xxx xx xx" className={!!phoneNumberIsNotGiven ? "p-invalid mr-2 w-full" : "w-full"}
                        value={phoneNumber} onChange={(e) => setPhoneNumber(e.value)} style={{ height: "3rem" }}></InputMask>
                );
            case "US":
                return (
                    <InputMask
                        mask="(999) 999 9999"
                        placeholder="(xxx) xxx xxxx"
                        className={
                            !!phoneNumberIsNotGiven
                                ? "p-invalid mr-2 w-full"
                                : "w-full"
                        }
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.value)}
                        style={{ height: "3rem" }}
                    />
                );
            default: 
                return (
                    <InputNumber className={!!phoneNumberIsNotGiven ? phoneNumber ? "w-full" : "p-invalid mr-2 w-full" : "w-full"}
                        value={phoneNumber} onChange={(e) => setPhoneNumber(e.value)} useGrouping={false} style={{ height: "3rem" }} />
                );
        }
    }

    return (
        <BlockUI
            blocked={blockUI}
            fullScreen
            style={{ backgroundColor: "transparent" }}
            template={
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <dotlottie-player
                        src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                        background="transparent"
                        speed="1"
                        style={{ width: "3rem", height: "3rem" }}
                        loop
                        autoplay
                    />
                </div>
            }
        >
            <Dialog footer={footerContent} header={headerContent}
                visible={addPatientDialogVisible}
                draggable={false}
                style={{ width: '45vw', borderRadius: '24px', overflow: "hidden" }}
                onHide={onaddPatientDialogHide} blockScroll>
                <div className="flex flex-column flex-wrap gap-4 justify-content-center p-2">
                    <div className='flex w-full gap-4'>
                        <div className="flex w-full flex-column gap-2">
                            <label>{t("patientName")} <i className="pi pi-asterisk p-overlay-badge" style={{ fontSize: '0.5rem', color: 'red' }}></i></label>
                            <InputText value={patientName}
                                style={{ borderRadius: "10px" }}
                                className={!!nameIsNotGiven ? "p-invalid mr-2" : undefined}
                                onChange={e => {
                                    if (/^[\p{L}\s]{0,20}$/u.test(e.target.value)) {
                                        setPatientName(e.target.value);
                                    }
                                }} />
                            {!!nameIsNotGiven && <Message severity="error" text={t(nameIsNotGiven)} />}
                        </div>

                        <div className="flex w-full flex-column gap-2" >
                            <label>{t("patientSurname")} <i className="pi pi-asterisk p-overlay-badge" style={{ fontSize: '0.5rem', color: 'red' }}></i></label>
                            <InputText value={patientSurname}
                                style={{ borderRadius: "10px" }}
                                className={!!surnameIsNotGiven ? "p-invalid mr-2" : undefined}
                                onChange={e => {
                                    if (/^[\p{L}\s]{0,20}$/u.test(e.target.value)) {
                                        setPatientSurname(e.target.value);
                                    }
                                }} />
                            {!!surnameIsNotGiven && <Message severity="error" text={t(surnameIsNotGiven)} />}
                        </div>
                    </div>

                    <div className="flex gap-3 align-items-start justify-content-center">
                        <div className="flex flex-column gap-2 w-full">
                            <label htmlFor="nationality">{t("country")} <i className="pi pi-asterisk p-overlay-badge" style={{ fontSize: '0.5rem', color: 'red' }}></i></label>
                                <Dropdown value={nationality} onChange={(e) => { setState({ name: "Illinois", code: "IL", flag: "https://upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Illinois.svg" }); setNationality(e.value); setCodeForPhoneNumber(e.value); }} options={countyList} optionLabel="name"
                                    valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} showClear filter
                                    className={!!nationalityIsNotGiven ? "p-invalid mr-2 w-full" : 'w-full'}
                                    style={{ height: "3rem", borderRadius: "10px" }}
                                    filterMatchMode='startsWith' />
                            {!!nationalityIsNotGiven && <Message severity="error" text={t(nationalityIsNotGiven)} />}
                        </div>
                        {nationality?.code === "US" && (
                            <div className="flex flex-column gap-2 w-full">
                                <label htmlFor="state">{t("state")} <i className="pi pi-asterisk p-overlay-badge" style={{ fontSize: '0.5rem', color: 'red' }}></i></label>
                                <Dropdown value={state} onChange={(e) => setState(e.value)} options={usaStateList} optionLabel="name"
                                    valueTemplate={usaSelectedStateTemplate} itemTemplate={usaStatesOptionTemplate} showClear filter
                                    className={!!stateIsNotGiven ? "p-invalid mr-2 w-full" : 'w-full'}
                                    style={{ height: "3rem", borderRadius: "10px" }}
                                    filterMatchMode='startsWith' />
                                {!!stateIsNotGiven && <Message severity="error" text={t(stateIsNotGiven)} />}
                            </div>
                        )}
                    </div>
                    <div className="flex flex-column gap-2" >
                        <label htmlFor="nationalIdentityNumber">{t("nationalIdentityNumber")} <i className="pi pi-asterisk p-overlay-badge" style={{ fontSize: '0.5rem', color: 'red' }}></i></label>
                        <InputText id="nationalIdentityNumber" value={nationalIdentityNumber}
                            className={!!nationalIdentityNumberIsNotGiven ? "p-invalid mr-2" : undefined}
                            style={{ borderRadius: "10px" }}
                            onChange={e => setNationalIdentityNumber(e.target.value)} />
                        {!!nationalIdentityNumberIsNotGiven && <Message severity="error" text={t(nationalIdentityNumberIsNotGiven)} />}
                    </div>

                    <div className="flex flex-column gap-2 addPatient">
                        <label htmlFor="phone">{t("phoneNumber")} <i className="pi pi-asterisk p-overlay-badge" style={{ fontSize: '0.5rem', color: 'red' }}></i></label>
                        <div className="combo-box flex align-content-center align-items-center ">
                            <Dropdown style={{ height: '3rem', width: '10rem' }} value={codeForPhoneNumber} options={countyList} optionLabel="name"
                                valueTemplate={selectedCountryTemplateForPhone} itemTemplate={countryOptionTemplateForPhone}
                                onChange={e => { setCodeForPhoneNumber(e.target.value); setPhoneNumber(undefined) }} filter filterMatchMode='startsWith' />
                            {renderPhoneNumberInput()}
                        </div>
                        {!!phoneNumberIsNotGiven && <Message severity="error" text={t(phoneNumberIsNotGiven)} />}
                    </div>

                    <div className="flex flex-column gap-2" >
                        <label htmlFor="nationality">{t("genderWord")} <i className="pi pi-asterisk p-overlay-badge" style={{ fontSize: '0.5rem', color: 'red' }}></i></label>
                        <Dropdown value={gender} onChange={(e) => setGender(e.value)} options={genderOptions} optionLabel="name"
                            showClear
                            className={!!genderIsNotGiven ? "p-invalid mr-2 w-full" : 'w-full'}
                            style={{ height: "3rem", borderRadius: "10px" }}
                            filterMatchMode='startsWith' />
                        {!!genderIsNotGiven && <Message severity="error" text={t(genderIsNotGiven)} />}
                    </div>
                </div>
            </Dialog>
        </BlockUI>
    )
}

export default AddPatientDialog;